import { api } from "./api-core";

export interface IUserCertificate {
  count: number;
  total_page: number;
  data: {
    cer_link: string;
    cer_name: string;
    icon_url: string;
    module_id: string;
    oa_file_name: string;
    oa_file_url: string;
    order_status: string;
    requestOrder: string;
    time: string;
    user_id: string;
  }[];
}

export const MyCertificateApi = {
  getUserCertificates: () => {
    return api
      .get(process.env.API_GET_USER_CERTIFICATE as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  sendRequestCert: (data: {
    billing_first_name: string;
    billing_last_name: string;
    billing_phone: string;
    billing_email: string;
    moduleId: string;
    cerName: string;
    cerLink: string;
    proofOfPayment: File;
  }) => {
    const formData = new FormData();
    // Duyệt qua tất cả các trường và thêm vào formData
    Object.keys(data).forEach((key) => {
      const k = key as keyof typeof data; // Ép kiểu key là một khóa hợp lệ của đối tượng data
      if (data[k] !== undefined) {
        if (data[k] instanceof File) {
          // Nếu là File, thêm trực tiếp vào formData
          formData.append(k, data[k]);
        } else if (Array.isArray(data[k])) {
          // Nếu là mảng, thêm từng phần tử vào formData
          (data[k] as string[]).forEach((item) => {
            formData.append(`${k}[]`, item);
          });
        } else {
          // Nếu là chuỗi hoặc các kiểu đơn giản khác
          formData.append(k, data[k] as string);
        }
      }
    });

    const url = process.env.API_SEND_REQUEST_CERT;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        return res.data;
      });
  },


  sendRequestCourse: (data: {
    billing_first_name: string;
    billing_last_name: string;
    billing_phone: string;
    billing_email: string;
    course_id: string;
    course_name: string;
    course_cost: string;
    course_currency: string;
    proofOfPayment: File;
    order_code: string;
    for_approval: string;
  }) => {
    const formData = new FormData();
    // Duyệt qua tất cả các trường và thêm vào formData
    Object.keys(data).forEach((key) => {
      const k = key as keyof typeof data; // Ép kiểu key là một khóa hợp lệ của đối tượng data
      if (data[k] !== undefined) {
        if (data[k] instanceof File) {
          // Nếu là File, thêm trực tiếp vào formData
          formData.append(k, data[k]);
        } else if (Array.isArray(data[k])) {
          // Nếu là mảng, thêm từng phần tử vào formData
          (data[k] as string[]).forEach((item) => {
            formData.append(`${k}[]`, item);
          });
        } else {
          // Nếu là chuỗi hoặc các kiểu đơn giản khác
          formData.append(k, data[k] as string);
        }
      }
    });

    const url = process.env.API_SEND_REQUEST_COURSE_ORDER;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        return res.data;
      });
  },
};
